module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M14-clean-4315400d215a18a1c6488034be5c82ae.png";